import { Link } from 'react-router-dom'
import { EmptyState } from '@/components/ui/Feedback'
export default function RetiredStorePage() {
  return <EmptyState title="Esta sección ya no está disponible" description="BsPOS ahora se dedica a soluciones de software, licencias y timbres. Los registros históricos se conservan."><Link className="ui-button" data-intent="primary" data-emphasis="solid" to="/soluciones">Ver soluciones de software</Link></EmptyState>
}
